import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { GraphqlProvider } from '@toro/common/shared/services/new-http/providers/graphql-api.http.service';

import { IOneViewPermissions } from '../../interfaces/one-view-permissions.interface';

@Injectable({
  providedIn: 'root',
})
export class OneViewPermissionsService {
  constructor(private graphqlApi: GraphqlProvider) {}

  public getViewPermissions(): Observable<IOneViewPermissions | null> {
    const data = this.graphqlApi
      .query({
        fetchPolicy: 'network-only',
        query: gql`
          query {
            home {
              viewPermissions {
                isExclusive
                showWalletOneView
              }
            }
          }
        `,
      })
      .then(
        ({ data }) => (data?.home?.viewPermissions as IOneViewPermissions) || null
      ) as Promise<IOneViewPermissions | null>;

    return from(data);
  }
}
